import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, ImageListItemBar } from "@mui/material";
import ImageListMUI from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import { Colors } from "../theme/colors";

type IProps = {
  images: any[];
  handleAction?: any;
  single?: boolean;
  logo?: boolean;
};

const singleImageStyles = {
  maxWidth: "370px",
  height: "246px",
};
const logoImageStyles = {
  maxWidth: "246px",
  height: "246px",
};

const ImageList: React.FC<IProps> = ({
  images,
  handleAction,
  single = false,
  logo = false,
}) => {
  if ((single && images[0]) || (logo && images[0])) {
    const image = images[0];

    return (
      <ImageListItem key={image.id}>
        <img
          crossOrigin="anonymous"
          src={image.url}
          srcSet={image.url}
          alt="event"
          loading="lazy"
          style={single ? singleImageStyles : logoImageStyles}
        />
        {handleAction && (
          <ImageListItemBar
            sx={{
              background: "transparent",
              m: 1,
            }}
            style={single ? { maxWidth: "354px" } : { maxWidth: "230px" }}
            position="top"
            actionIcon={
              <IconButton
                sx={{
                  backgroundColor: Colors.white,
                  "&:hover": {
                    backgroundColor: Colors.white,
                  },
                }}
                onClick={() => handleAction(image)}
              >
                <DeleteIcon color="error" />
              </IconButton>
            }
            actionPosition="right"
          />
        )}
      </ImageListItem>
    );
  }

  return (
    <ImageListMUI cols={3} sx={images.length > 3 ? { height: 300 } : {}}>
      {images.map((image: any, index: number) => (
        <ImageListItem key={image.id || index}>
          <img
            crossOrigin="anonymous"
            src={image.url}
            srcSet={image.url}
            alt="event"
            loading="lazy"
          />
          {handleAction && (
            <ImageListItemBar
              sx={{
                background: "transparent",
                m: 1,
              }}
              position="top"
              actionIcon={
                <IconButton
                  sx={{
                    backgroundColor: Colors.white,
                    "&:hover": {
                      backgroundColor: Colors.white,
                    },
                  }}
                  onClick={() => handleAction(image)}
                >
                  <DeleteIcon color="error" />
                </IconButton>
              }
              actionPosition="right"
            />
          )}
        </ImageListItem>
      ))}
    </ImageListMUI>
  );
};
export default ImageList;
